import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  hero: {
    alignItems: 'flex-start',
    backgroundColor: theme.palette.grey2,
    color: 'white',
    display: 'flex',
    gap: 16,
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
    textAlign: 'center',
    borderRadius: '5px 5px 0px 0px',
    padding: 24,
    minHeight: 168,

    [theme.breakpoints.up('sm')]: {
      borderRadius: '5px 5px 0 0',
    },

    '& .courtesy-hold': {
      marginBottom: '-12px',
      fontSize: theme.typography.pxToRem(12),
      textTransform: 'uppercase',
      letterSpacing: '1.2px',
      fontFamily: theme.typography.proxima.semiBold,

      [theme.breakpoints.up('lg')]: {
        fontSize: theme.typography.pxToRem(16),
        letterSpacing: '1.6px',
      },
    },

    '& p': {
      fontFamily: theme.typography.proxima.semiBold,
      fontSize: theme.typography.pxToRem(30),
      lineHeight: '120%',
      textAlign: 'left',

      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(36),
      },
    },
    '& h1, & p, & button': {
      position: 'relative',
      zIndex: '1',
    },

    '& .gradientFilter': {
      background: 'linear-gradient(180deg, rgba(6, 21, 86, 0.00) 0%, rgba(0, 0, 0, 0.60) 105.06%)',
      borderRadius: '5px 5px 0px 0px',
      height: '100%',
      position: 'absolute',
      width: '100%',
      zIndex: '1',
      marginLeft: '-24px',
    },
    '& .heroImage': {
      borderRadius: '5px 5px 0px 0px',
      height: '100%',
      left: '0',
      position: 'absolute',
      top: '0',
      width: '100%',
      zIndex: '0',

      [theme.breakpoints.up('sm')]: { borderRadius: '5px 5px 0 0' },
    },
  },

  higlitedDescription: {
    padding: 24,
    fontSize: theme.typography.pxToRem(30),
    fontFamily: theme.typography.proxima.semiBold,
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 24px',
    color: theme.palette.white,
    background: theme.palette.blue2,
    borderRadius: '0px 0px 5px 5px',
    margin: 0,
    width: '100%',
    height: 'auto',

    '& .MuiButton-label': {
      textAlign: 'left',

      '& .container': {
        display: 'flex',
        gap: 8,
        flexDirection: 'column',

        [theme.breakpoints.up('xl')]: {
          flexDirection: 'row',
          gap: 16,
        },
      },
    },

    '& a': {
      color: 'white',
      textDecoration: 'none',
    },

    '& .container': {
      display: 'flex',
      gap: 8,
      flexDirection: 'column',

      [theme.breakpoints.up('sm')]: {
        gap: 16,
        flexDirection: 'row',
      },
    },

    '& h4': {
      textTransform: 'uppercase',
      fontFamily: theme.typography.proxima.semiBold,
      lineHeight: '120%',
    },

    '& p': {
      textAlign: 'left',
      lineHeight: '120%',
    },
    '& svg': { transform: 'scale(1.2)' },
  },

  buttonHover: {
    '&:hover': { backgroundColor: '#004bb0' },
  },
}));

export default useStyles;
